import { useScreenStore } from '../stores/useScreenStore';
import { useAuthGuard } from '../hooks/auth/useAuthGuard';
import { useOnboardingGuard } from '../hooks/auth/useOnboardingGuard';
import { useCurrentScreen } from '../hooks/screen/useCurrentScreen';
import { useSocketConnection } from '../hooks/socket/useSocketConnection';
import { useClientsSocket } from '../hooks/clients/useClientsSocket';
import { useClientsChannel } from '../hooks/clients/useClientsChannel';
import { useLinesChannel } from '../hooks/lines/useLinesChannel';
import { useMapChannel } from '../hooks/map/useMapChannel';
import { usePezinhoChannel } from '../hooks/map/usePezinhoChannel';
import { useOrderChannel } from '../hooks/order/useOrderChannel';
import { usePontosItinerarioChannel } from '../hooks/pontos/usePontosItinerarioChannel';
import { useVehiclesSocket } from '../hooks/vehicles/useVehiclesSocket';
import { useDriversSocket } from '../hooks/drivers/useDriversSocket';
import { useTurnosChannel } from '../hooks/turnos/useTurnosChannel';
import { useTurnosSocket } from '../hooks/turnos/useTurnosSocket';
import { useLinesSocket } from '../hooks/lines/useLinesSocket';
import { useTripsSocket } from '../hooks/trips/useTripsSocket';
import { useScreenSocket } from '../hooks/screen/useScreenSocket';
import { useHomeChannel } from '../hooks/home/useHomeChannel';
import { useDateChannel } from '../hooks/date/useDateChannel';
import { useOperationalMapModeChannel } from '../hooks/operationalMapMode/useOperationalMapModeChannel';
import { useHourRangeChannel } from '../hooks/hourRange/useHourRangeChannel';
import { useLoadingChannel } from '../hooks/loading/useLoadingChannel';
import { useMonitorWindows } from '../hooks/screen/useMonitorWindows';
import { useChegadasViagensSocket } from '../hooks/chegadasViagens/useChegadasViagensSocket';
import { useSchedulesSocket } from '../hooks/schedules/useSchedulesSocket';
import { useTripAnalysisSubscriptions } from '../hooks/analysis/useTripAnalysisSubscriptions';
import { useTripAlertsAnalysisSocket } from '../hooks/analysis/useTripAlertsAnalysisSocket';
import { useTripStatusAnalysisSocket } from '../hooks/analysis/useTripStatusAnalysisSocket';
import { useTripPositionsAnalysisSocket } from '../hooks/analysis/useTripPositionsAnalysisSocket';
import { useMapSocket } from '../hooks/map/useMapSocket';
import { usePontosOperacionaisSocket } from '../hooks/pontosOperacionais/usePontosOperacionaisSocket';
import { usePontosSocket } from '../hooks/pontos/usePontosSocket';
import { useMonitorModePermissions } from '../hooks/screen/useMonitorModePermissions';
import useOperationalRangeWatcher from '../hooks/hourRange/useOperationalRangeWatcher';
import TopAlerts from '../components/hashs/TopAlerts';
import List from '../components/List';

const Home = () => {
  
  const monitorMode = useScreenStore(state => state.monitorMode);
  const screenBlocked  = useScreenStore(state => state.screenBlocked);

  useCurrentScreen('Home');
  const { hasUser } = useAuthGuard();
  const { canRender } = useOnboardingGuard('home');
  useLoadingChannel();
  useMonitorModePermissions();
  useSocketConnection();
  useScreenSocket();
  useClientsSocket();
  useClientsChannel();
  useOrderChannel();
  useLinesChannel();
  useDateChannel();
  useOperationalMapModeChannel();
  useHourRangeChannel();
  usePontosItinerarioChannel();
  useMapChannel();
  usePezinhoChannel();
  useTurnosChannel();
  useTurnosSocket();
  useVehiclesSocket();
  useDriversSocket();
  useLinesSocket();
  useTripsSocket();
  useHomeChannel();
  useMonitorWindows();
  useChegadasViagensSocket();
  useSchedulesSocket();
  useTripAnalysisSubscriptions();
  useTripAlertsAnalysisSocket();
  useTripStatusAnalysisSocket();
  useTripPositionsAnalysisSocket();
  useMapSocket();
  useOperationalRangeWatcher();
  usePontosSocket();
  usePontosOperacionaisSocket();

  if(!hasUser || !canRender || screenBlocked) return null;

  return (
    <>
      {monitorMode === 1 &&
        <TopAlerts/>
      }
      <List/>
    </>
  );
};

export default Home;